<script setup>
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Translations from '@/provider/translations.js'

const props = defineProps(['updatePageTitle'])
const route = useRoute()

onMounted( () => {
  props.updatePageTitle(route.meta.title)
})

</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="callout callout-danger">
        <p>{{Translations.getTrans('app.errors.403.message')}}</p>
      </div>
    </div>
  </div>
</template>
